import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import css from '../css/Addcase.module.css'
import { Link } from 'react-router-dom'
import Header from '../Components/Header'
import Rightcontainer from '../Components/Rightcontainer'
import Swal from 'sweetalert2'
import socket from '../Components/socket'
import { useTheme } from '../../ThemeContext'
import { apiRequest } from '../../apiService/allApi'

const Redeem = ({ walletUpdate }) => {
  const history = useHistory()

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 

  const [amount, setamount] = useState()
  const [userAllData, setUserAllData] = useState()
  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    const res = await apiRequest(`me`, "GET", null, headers)

    setUserAllData(res.data)

  }

  useEffect(() => {
    let access_token = localStorage.getItem('token')
    access_token = localStorage.getItem('token')
    if (!access_token) {
      window.location.reload()
      history.push('/login')
    }
    role()
  }, [])

  const deposit = async () => {
    if (amount && amount >= 95 && amount <= 100000) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }


      const res = await apiRequest(`referral/to/wallet`, "POST", { amount }, headers)


      if (res.data.msg === 'Invalid Amount') {
        Swal.fire({
          title: "You don't have sufficient amount",
          icon: 'warning',
          confirmButtonText: 'OK'
        })
      } else {
        Swal.fire({
          title: 'success',
          icon: 'success',
          confirmButtonText: 'OK'
        })
      }
    } else {
      let msg = 'Enter Amount'
      if (!amount) {
        msg = 'Enter Amount'
      } else if (95 <= amount <= 100000) {
        msg = 'Amount should be more than 100.'
      }
      Swal.fire({
        title: msg,
        icon: 'Error',
        confirmButtonText: 'OK'
      })
    }
  }

  // change theme 
  const theme = localStorage.getItem('theme')
  const styles = {
    backgroundColor: theme === 'light' ? '#fff' : 'black',
    color: theme === 'light' ? 'black' : '#fff',
  };

  return (
    <>
      {/* <Header user={userAllData} /> */}
      <div className="pl_redeem_panel">

        {/* HEADER */}
        <div className="pl_redeem_header">

          <div className="pl_redeem_header_icon">
            ₹
          </div>

          <div className="pl_redeem_header_content">

            <span className="pl_redeem_eyebrow">
              PRINCE LUDO REWARDS
            </span>

            <h2>
              Redeem Referral Balance
            </h2>

            <p>
              Convert referral balance to Prince Ludo coins
            </p>

          </div>

        </div>


        {/* TDS NOTICE */}
        <div className="pl_redeem_tds">

          <div className="pl_redeem_tds_icon">
            <img src="/images/rupee.png" alt="" />
          </div>

          <div className="pl_redeem_tds_content">

            <strong>
              TDS (0%) will be deducted after earning of ₹1 Cr.
            </strong>

            <span>
              Minimum withdrawal amount ₹100
            </span>

          </div>

        </div>


        {/* INFO */}
        <div className="pl_redeem_info">

          <img
            src="/refer-box.png"
            alt=""
            className="pl_redeem_info_img"
          />

          <span>
            Money will be added to Prince Ludo coins.
          </span>

        </div>


        {/* AMOUNT */}
        <div className="pl_redeem_amount_section">

          <div className="pl_redeem_amount_heading">

            <span>
              Enter Amount
            </span>

            <small>
              Min ₹100 · Max ₹10,000
            </small>

          </div>


          <div className="pl_redeem_input_box">

            <span className="pl_redeem_input_symbol">
              ₹
            </span>

            <input
              type="number"
              value={amount}
              placeholder="0"
              className="pl_redeem_input"
              onChange={(e) =>
                setamount(parseInt(e.target.value))
              }
            />

          </div>

        </div>


        {/* BUTTON */}
        <button
          className="pl_redeem_action"
          onClick={() => deposit()}
        >
          <span>Redeem Now</span>

          <span className="pl_redeem_action_arrow">
            →
          </span>
        </button>

      </div>


    </>
  )
}
export default Redeem
